import { ImageAtoms, Pill } from '@vfit/shared/atoms';
import { IArticleCard } from '../../articleCard.models';
import {
  CardContainerLarge,
  ContentContainerLarge,
  CreatorLarge,
  PillElement,
  TitleLarge,
  TopicLarge,
  TopImageContainerLarge,
} from '../../articleCard.style';

export const ArticleCardLarge = ({
  title,
  topic,
  creator,
  backgroundImg,
  pillText,
  isExternalImages,
  ignoreSize,
  blurredBackgroundImg,
}: Omit<IArticleCard, 'variant'>) => (
  <CardContainerLarge ignoreSize={ignoreSize}>
    {backgroundImg && title && (
      <TopImageContainerLarge ignoreSize={ignoreSize}>
        <ImageAtoms
          nameCard={title}
          image={backgroundImg}
          placeholder={blurredBackgroundImg ? 'blur' : 'empty'}
          blurDataURL={blurredBackgroundImg}
          objectFit="cover"
          loading="lazy"
          external={isExternalImages}
          style={{
            borderRadius: '20px 20px 0 0',
          }}
          type="default"
        />
      </TopImageContainerLarge>
    )}
    {pillText && (
      <PillElement>
        <Pill label={pillText} />{' '}
      </PillElement>
    )}
    <ContentContainerLarge>
      {topic && <TopicLarge>{topic}</TopicLarge>}
      {title && <TitleLarge>{title}</TitleLarge>}
      {creator && <CreatorLarge>{creator}</CreatorLarge>}
    </ContentContainerLarge>
  </CardContainerLarge>
);
